import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

export interface ActivationState {
  allowedPages: string[] | null; // null = 全部允许，[] = 全部禁止，[...] = 白名单
  loaded: boolean;
}

const initialState: ActivationState = {
  allowedPages: null,
  loaded: false,
};

export const fetchActivationInfo = createAsyncThunk(
  'activation/fetchInfo',
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get('/server/activation-info');
      return res.data;
    } catch {
      return rejectWithValue('获取激活信息失败');
    }
  }
);

const activationSlice = createSlice({
  name: 'activation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchActivationInfo.fulfilled, (state, action) => {
      state.allowedPages = action.payload.allowedPages;
      state.loaded = true;
    });
    builder.addCase(fetchActivationInfo.rejected, (state) => {
      state.allowedPages = null; // 获取失败时默认全部允许
      state.loaded = true;
    });
  },
});

export default activationSlice.reducer;
